import logo from './logo.svg';
import './App.css';
import About from "./pages/About";

import Home from "./pages/Home";
import Services from "./pages/Service";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Portfolio from "./pages/Portfolio";
import { BrowserRouter as Router, Routes, Route,HashRouter } from "react-router-dom";

function App() {
  return (
    <>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Team" element={<Team />} />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/Contact" element={<Contact />} />
        </Routes>
      </HashRouter>
      
    </>
  );
}

export default App;
